import React from 'react';
import PropTypes from 'prop-types';

import {
    ButtonGroup,
    Button,
    Spacer,
    Text,
} from '@zillow/constellation';
import { Col, Row } from '@zillow/zrs-comet';

const propTypes = {
    title: PropTypes.string,
    firstTabTitle: PropTypes.string,
    secondTabTitle: PropTypes.string,
    showTabs: PropTypes.bool,
    activeIndex: PropTypes.number,
    isLoading: PropTypes.bool,
    onTabClick: PropTypes.func,
};

const defaultProps = {
    title: '',
    firstTabTitle: 'Average',
    secondTabTitle: 'Total',
    showTabs: false,
    activeIndex: 0,
    isLoading: false,
    onTabClick: () => {},
};

const GraphTitle = ({
    title, showTabs, onTabClick, firstTabTitle, secondTabTitle, activeIndex, isLoading,
}) => (
    <Spacer marginBottom="sm">
        <Row>
            <Col md={12} lg={6} xl={8}>
                <Spacer marginBottom="xs">
                    <Text fontType="h6">{title}</Text>
                </Spacer>
            </Col>
            {showTabs && (
                <Col md={12} lg={6} xl={4}>
                    <ButtonGroup conjoined={true} fluid={true}>
                        <Button
                            onClick={() => onTabClick(0)}
                            buttonType={activeIndex === 0 ? 'primary' : 'tertiary'}
                            disabled={isLoading}
                        >
                            {firstTabTitle}
                        </Button>
                        <Button
                            onClick={() => onTabClick(1)}
                            buttonType={activeIndex === 1 ? 'primary' : 'tertiary'}
                            disabled={isLoading}
                        >
                            {secondTabTitle}
                        </Button>
                    </ButtonGroup>
                </Col>
            )}
        </Row>
    </Spacer>
);

GraphTitle.propTypes = propTypes;
GraphTitle.defaultProps = defaultProps;

export default GraphTitle;
